export const UPPER_AND_LOWER_CHARS = /[a-z].*[A-Z]|[A-Z].*[a-z]/
export const CHARS_AND_NUMBERS = /(?=.*[A-Za-z])(?=.*[0-9])/
export const PLUS_SYMBOL_OR_NUMBERS = /(?=.*[+0-9\s])/
// eslint-disable-next-line max-len
export const SPECIAL_CHAR = /(?=.*['ø®å√µ≤≥÷¡€#¢∞¶•ªº–≠[\]\\|\-`œ∑´†¥^π“«æ…¬˚∆˙©ƒ∂ßΩ≈ç~∫¨!@£$%^&*()_+=±§{}":;<>,.?/œ∑´†¥¨])/
// eslint-disable-next-line max-len
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/